import * as me from './me';
import * as team from './team';

const actions = {
  me,
  team,
};

export default actions;
